<template>
    <div class="app" id="gwi-login">
        <form class="login-form" action="" v-on:submit="submitLogin"  v-show="loginShow">
            <div class="form-line">
                <span class="form-icon phone"></span>
                <input type="text" id="login-phoneno" class="gwi-ipt" v-model="param.mobileNo" placeholder="手机号码">
            </div>
            <verify-code class="login-line" v-model="verifyCode" namespace="login" url="/app/user/send" myprop="isAgreed" :param="param">
                <span class="form-icon pwd"></span>
            </verify-code>
            <div class="form-line clear-border" style="height:40px;line-height:45px;">
                <label style="form-icon">
                    <input type="checkbox" class="cb" name="name" id="login-check" v-model="isAgreed">
                    <label for="login-check" class="icon-cb">
                    </label>
                </label>
                <a style="text-decoration: underline;" id="login-agreement" class="f-strong" @click.prevent="showAgreement()">同意软件许可及服务协议</a>
            </div>

            <div v-show="configShown">
                <div class="form-inline" >
                    <input type="text"  class="gwi-ipt" v-model="backendUrl" placeholder="后台地址"></input>
                </div>
                <button type="button" @click="setUrl">OK</button>
            </div>
            <div class="flat-row">
                <button class="btn-ok" type="submit" :disabled="!isAgreed||!verifyCode||!param.mobileNo" style="width: 90%">登录</button>
            </div>
        </form>
    </div>
</template>
<script>
    import VerifyCode from '../../components/VerifyCode'
    import utils from 'utils'
    module.exports = {
        data: function() {
            return {
                password: '',
                verifyCode: '',
                isAgreed: true,
                configShown: false,
                agreement: '',
                agreementToggle: false,
                backendUrl: localStorage.backendUrl,
                param: {
                    mobileNo: localStorage.mobileNo,
                    //1：注册/登录  2：修改密码  3：修改手机号
                    operateType: '1'
                },
                loginShow: true,
            }
        },
        components: {
            VerifyCode
        },
        mounted() {
            navigator.splashscreen && navigator.splashscreen.hide();
            localStorage.removeItem('tokenId');
            sessionStorage.removeItem('tokenId');
            localStorage.removeItem('deviceId');
            sessionStorage.removeItem('deviceId');
            //判断是否存在tokenId,且当前界面code失效
            var query = this.$router.currentRoute.query
            var loginCode = query.code
            if (loginCode && loginCode !== localStorage.loginCode) {
                //缓存最新code给后台
                localStorage.setItem('deviceId', localStorage.loginCode);
                sessionStorage.setItem('deviceId', localStorage.loginCode);
                localStorage.setItem('loginCode', loginCode);
                window.http.headers.common['deviceId'] = loginCode
            }
        },
        methods: {
            goHome() {
                this.$store.commit('changeState', 'Home');
                this.$router.replace('/')
            },
            showAgreement() {
                this.$router.push('Agreement')
            },
            submitLogin: function($event) {
                $event.preventDefault();
                var msg = utils.verifyNo().butVerifyNo(this);
                if (msg) {
                    return this.$utils.alert(msg);
                }
                this.$http.post('/app/user/login', {
                    mobileNo: this.param.mobileNo,
                    loginType: '1',
                    code: this.verifyCode
                }).then((res) => {
                    var data = res.body;
                    if (data.resultCode === this.constant.RESULT_SUCCESS) {
                        localStorage.setItem('tokenId', data.data.tokenId);
                        sessionStorage.setItem('tokenId', data.data.tokenId);
                        localStorage.mobileNo = this.param.mobileNo;
                        http.headers.common['tokenId'] = data.data.tokenId;
                        var loginStore = this.$store.state.paramModule.param.login;
                        if (loginStore && loginStore.path) {
                            var params = loginStore.params;
                            var path = loginStore.path;
                            var query = loginStore.query;
                            this.$router.replace({params: params, path: path, query: query});
                        } else {
                            this.$router.replace('/');
                        }
                    } else {
                        this.$utils.alert(data.resultMsg);
                    }
                })
                return false;
            },
            showConfig() {
                this.configShown = true;
            },
            setUrl() {
                localStorage.backendUrl = this.backendUrl;
                this.configShown = false;
            }
        },
        beforeRouteLeave (to, from, next) {
            // 导航离开该路由时保存输入号码
            if (this.param.mobileNo) {
                localStorage.mobileNo = this.param.mobileNo;
                next();
            }else{
                next();
            }
        }
    }
</script>
<style>
    .login-line{
        padding-top:10;
        padding-bottom:10;
    }
    .flat-row {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// Login.vue?ea9516a8